import React from 'react';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useLocation } from '@/contexts/LocationContext';

// Admin/super-admin-only site switcher. Hidden for tenants/owners (they're RLS-scoped to one site).
export const LocationSwitcher: React.FC = () => {
  const { locations, selectedLocationId, setSelectedLocationId, canSwitch } = useLocation();
  const { t } = useTranslation();
  if (!canSwitch) return null;

  return (
    <Select
      value={selectedLocationId ?? 'all'}
      onValueChange={(v) => setSelectedLocationId(v === 'all' ? null : v)}
    >
      <SelectTrigger className="h-9 w-[148px] text-sm" aria-label={t('header.switchSite')}>
        <MapPin className="w-4 h-4 mr-1 shrink-0 text-blue-600" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('header.allZanzibar')}</SelectItem>
        {locations.map((l) => (
          <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LocationSwitcher;
